import React, { useEffect, useRef, useState } from "react";

import ImageCard from "./ImageCard";

import { extractJSONFromText, jsonToMarkdown } from 'utils/function';
import useAppState from 'context/useAppState';
import { getLLMAgentRAGCreatePayload, getLLMAgentRAGUpdatePayload } from 'services/llm/payloads';
import { useParams } from 'react-router-dom';
import { generateImage } from "services/llm";
import { getLLMAgentCreateImagePayload } from "services/llm/payloads";
import { cloneDeep, has, isEqual } from "lodash";
import { updateChatMessage } from "services/chat";
import { addHistoryData, updateTask } from "services/event";
import Toast from "components/common/Toast";
import Loader from "components/Loader";

const ImageCardContainer = ({ messageData }: any) => {
	const [cardItems, setCardItems] = useState<any[]>([]);
	const { boardData, cards: cardList, columns, updateState, selectedCardDetail } = useAppState("cardWrapper");
	const { draftEvent, draftEventTasks } = useAppState('newFeteChat')

	const [currentTask, setCurrentTask] = useState<any>(null)
	let savingIsFavorite = false;

	const [saveBtnDisable, setSaveBtnDisable] = useState(true)
	const [oldData, setOldData] = useState<any>(null)
	const [isEditMode, setIsEditMode] = useState(false)
	const { setState: setEventDataState, sendButtonRef, currentTaskObj } = useAppState("eventData");
	const [selectedItems, setSelectedItems] = useState<any>([]);
	const [savedItems, setSavedItems] = useState<any>([]);
	let clonedFormData = useRef<any>(null);

	const fetchData = async () => {
		const { content, _id: messageId } = messageData;
		const jsonDetails = extractJSONFromText(content);
		setIsEditMode(jsonDetails?.isEdit || false)
		const { items = [] } = jsonDetails;
		let shouldUpdateMessage = false;

		// To manage history for selected theme 
		const updatedItem = cloneDeep(items).find((itm: any) => !itm.isHidden);
		setOldData(updatedItem)

		// TODO: disabling image generation, will be enabled in future
		// Promise.all(items.map((cardItem: any, index: number) => {
		// 	console.log({ cardItem })
		// 	return new Promise((resolve: any, reject: any) => {
		// 		if (!has(cardItem, "imageUrl")) {
		// 			// Generate an image
		// 			generateImage(
		// 				getLLMAgentCreateImagePayload({
		// 					prompt: `Image Description: ${cardItem?.['imageDescription'] || 'Themes'} \n\nGenerate image based on given Image Description.`,
		// 				})
		// 			).then((response: any) => {
		// 				shouldUpdateMessage = true;
		// 				const _copy_items = items
		// 				_copy_items[index].imageUrl = response.data.response
		// 				setCardItems(_copy_items);
		// 				resolve();
		// 			});
		// 		}

		// 	})
		// }))

		setCardItems(items);
		if (shouldUpdateMessage) {
			await updateChatMessage(messageId, { content: JSON.stringify({ items, renderImages: true }) });
		}
	};

	const getCurrentTaskDetail = () => {
		let currentTaskDetails: any;
		if (selectedCardDetail && id) {
			const updatedSelectedCardDetail = { ...selectedCardDetail }
			const latestTasks = updatedSelectedCardDetail?.tasks || [];
			const currentTask = latestTasks.find((t: any) => JSON.stringify(t._id) == JSON.stringify(jsonDetails?.taskId));
			setCurrentTask(currentTask)
		} else if (draftEventTasks && draftEventTasks?.length > 0) {
			currentTaskDetails = draftEventTasks?.find((t: any) => t._id == jsonDetails.taskId);
			setCurrentTask(currentTaskDetails)
		}
		return currentTaskDetails;
	}

	useEffect(() => {
		getCurrentTaskDetail()
	}, [draftEventTasks])

	useEffect(() => {
		fetchData();
		getCurrentTaskDetail()
	}, [messageData._id, messageData?.newMessageId]);

	useEffect(() => {
		if (isEditMode) {
			clonedFormData.current = cloneDeep(cardItems)
		}
	}, [isEditMode])

	const { content, _id: messageId, taskId } = messageData;
	const jsonDetails = extractJSONFromText(content);

	const { id, draftEventId } = useParams();
	const { setState: setChatMessagesState, updateMessageContent, getUserChatSessionMessages } = useAppState('chatMessages')
	const { currentSession, updateRAGEntryOfFete } = useAppState('chatBox')

	const getEventId = () => {
		if (id) {
			return id;
		}
		if (draftEventId) {
			return draftEventId;
		}
		if (draftEvent && draftEvent?._id) {
			return draftEvent?._id;
		}
	}

	const fetchInitData = async () => {
		const chatSessionMessages = await getUserChatSessionMessages(currentSession?._id)
		setChatMessagesState({ messageHistory: [...chatSessionMessages] })
	}

	useEffect(() => {
		// fetchInitData()
		getCurrentTaskDetail()
	}, [])

	const updateMessage = async (index: number, updatedData: any, field: any) => {
		const updatedListItems = cardItems.map((item: any, idx: any) => {
			if (idx === index) {
				return { ...item, [field]: updatedData[field] };
			}
			return item;
		});
		setCardItems(updatedListItems)

		// New Additions
		handleSelections(index)

		// Call API on favorite select/unselect
		savingIsFavorite = field === 'is_favorite'
		if (field == 'is_favorite' && updatedListItems[index]['selected'] === true) {
			await save(true)
		}
	};

	const handleSelections = (index: number) => {
		if (!isEditMode) {
			const clickedItem = cardItems[index];
			let newSelectedItems;

			if (selectedItems.includes(clickedItem.title) && clickedItem?.selectedTags?.length == 0) {
				newSelectedItems = selectedItems.filter((title: any) => title !== clickedItem.title);
			} else {
				newSelectedItems = [...selectedItems, clickedItem.title];
			}

			setSelectedItems(newSelectedItems);
			const isSaveDisabled =
				newSelectedItems.length === 0 ||
				newSelectedItems.every((title: any) => savedItems.includes(title));

			setSaveBtnDisable(isSaveDisabled)
			setEventDataState({ unsavedChanges: !isSaveDisabled })
		} else {
			const isSame = isEqual(cardItems?.[0]?.selectedTags, clonedFormData.current?.[0]?.selectedTags);
			setSaveBtnDisable(isSame)
			setEventDataState({ unsavedChanges: !isSame })
		}
	}

	const handleRAGCall = async (content: any) => {
		const userData = JSON.parse(localStorage.getItem('userData') as string)
		const userEmail = localStorage.getItem('userEmail')
		const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)

		let ragPayload: any = {
			session_id: currentSession?._id,
			text_content: jsonToMarkdown(content),
			text_prefix: ``
		}

		const isDraft = draftEventId ? true : false
		const ragMetaData = {
			userId: userData?.id,
			userEmail: userEmail,
			teamId: currentTeam?.currentTeamId,
			eventId: getEventId(),
			is_draft: isDraft,
			taskId: currentTaskObj?.task_id || currentTask?._id || jsonDetails.taskId,
			updatedAt: new Date().toISOString(),
			cardId: selectedCardDetail?._id
		}

		let currentTaskDetails = currentTask;
		if (!currentTaskDetails) {
			currentTaskDetails = getCurrentTaskDetail();
		}

		// if (!savingIsFavorite) await updateCardTask(true)

		ragPayload = { ...ragPayload, document_path: messageId, additional_metadata: ragMetaData }

		try {
			await updateRAGEntryOfFete(getLLMAgentRAGUpdatePayload(ragPayload))
		} catch (error) {
			// handleApiCases(false)
			return;
		}

		savingIsFavorite = false
	}

	const save = async (fromFavorite = false) => {
		setSaveBtnDisable(true)

		let filteredCardItems = [...cardItems];
		filteredCardItems.map((fc: any) => {
			fc['selectedTags'] = (fc['selectedTags'] || []).filter((st: any) => st)
			fc['tags'] = (fc['tags'] || []).filter((st: any) => st)
		})

		// For Removing Extra Properties Added While Directly Opening Fete Buddy
		const itemsForDB = cloneDeep(filteredCardItems)
		const updatedItem = itemsForDB.find((itm: any) => !itm.isHidden)
		itemsForDB.map((idb: any) => {
			if (idb.hasOwnProperty('showCheckBox')) delete idb.showCheckBox;
			if (idb.hasOwnProperty('isHidden')) delete idb.isHidden;
			if (idb.hasOwnProperty('ragId')) delete idb.ragId;
		})

		setCardItems(filteredCardItems)

		const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)

		const isDraft = draftEventId ? true : false;

		const messagePayload = {
			content: JSON.stringify({ "renderImages": true, 'items': itemsForDB }),
			teamId: currentTeam?.currentTeamId,
			eventId: getEventId(),
			is_draft: isDraft,
			taskId: currentTaskObj?.task_id || currentTask?._id || jsonDetails.taskId,
			cardId: selectedCardDetail?._id,
			blockId: selectedCardDetail?.columnId || selectedCardDetail?.block_id
		}

		try {
			// Add history data for added/updated tags
			const isSameLength = (oldData?.selectedTags || []).length == (updatedItem?.selectedTags || []).length
			const allSameTagValues = (oldData?.selectedTags || []).every((value: any) => (updatedItem?.selectedTags || []).includes(value))
			if (oldData?.ragId && !isSameLength || !allSameTagValues) {
				const addHistoryPayload = {
					ragId: oldData?.ragId,
					taskTitle: updatedItem?.title,
					taskType: 'items',
					actionType: 'tagsUpdated',
					oldValue: oldData.selectedTags,
					newValue: updatedItem.selectedTags
				}
				await addHistoryData(addHistoryPayload)
			}

			await updateMessageContent(messageId, messagePayload)
		} catch (error) {
			if (!fromFavorite) handleApiCases(false)
			return;
		}

		const selectedCardItems = cloneDeep(itemsForDB?.filter((ci: any) => ci?.selected))
		selectedCardItems.map((fc: any) => {
			fc['tags'] = (fc['selectedTags'] || []).filter((st: any) => st)
			delete fc['selectedTags']
			if (fc?.imageDescription) delete fc.imageDescription
			delete fc['selected']
			if (fc?.description) delete fc.description;
			if (fc?.imageUrl) delete fc.imageUrl
			if (fc?.type == 'crawled') {
				delete fc.type
				delete fc.tags;
			}
		})

		setSavedItems([...savedItems, ...selectedItems]);
		setSelectedItems([]);
		setSaveBtnDisable(true);
		setEventDataState({ unsavedChanges: false })

		await handleRAGCall({ heading: currentTask?.title ? currentTask?.title : jsonDetails?.heading, items: selectedCardItems })

		// setSaveBtnDisable(false)
		if (!fromFavorite) handleApiCases(true)
	}

	const handleApiCases = (isSuccess: boolean) => {
		if (isSuccess) {
			Toast.success('', 'Saved successfully')
		} else {
			Toast.error('', 'Failed to save')
		}
	}

	const showMore = () => {
		const tasks = [
			{ name: 'decor themes', text: 'Brainstorm decor styles' },
			{ name: 'venue styles', text: 'Brainstorm venue styles' },
			{ name: 'venue', text: 'Recommend venue' }
		]
		const queryText = tasks.find((tsk: any) => tsk.name.toLowerCase() == currentTaskObj?.task_name?.toLowerCase())?.text || ""
		setEventDataState({ bestActionQuery: queryText, bestActionPrompt: currentTaskObj.promptKey || '', currentTaskObj })
		sendButtonRef.current = true;
	}

	return (
		<>
			<div className="rounded-lg border border-[#EAECF0] pt-3 pb-4 px-4 bg-[#F9FAFB] mb-6">
				<div className="flex w-[calc(100vw_-_614px)] overflow-x-auto gap-x-4 mb-6 on-hover-show-scrollbar">
					{cardItems && cardItems?.length > 0 && cardItems?.map((item: any, index: number) => (
						<React.Fragment key={index}>
							<ImageCard data={item} index={index} updateMessage={updateMessage} />
						</React.Fragment>
					))}
				</div>
				<div className="flex items-center gap-x-2 justify-end">
					{
						!isEditMode &&
						<button
							type="button"
							className={`text-sm text-white bg-[#1E0AF5] hover:bg-[#120693] font-interMedium rounded-lg px-8 py-2`}
							onClick={() => showMore()}
						>
							Show More
						</button>
					}
					<button
						type="button"
						className={`text-sm text-white bg-[#1E0AF5] hover:bg-[#120693] font-interMedium rounded-lg px-8 py-2 ${saveBtnDisable ? 'button-disabled' : ''}`}
						onClick={() => save(false)}
						disabled={saveBtnDisable}
					>
						Shortlist
					</button>
				</div>
			</div>
		</>
	)
}

export default React.memo(ImageCardContainer);